import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    class: { "view-annotations-button-container": true, active: this.isAttributeEnabled(`active`) }
  }, this.attr(`num-annotations`));
}
